window.addEventListener("DOMContentLoaded", function() {
    faqSection ()
});

function faqSection () {
    const questions = document.querySelectorAll(".faq-item__question");
    if ( !questions.length ) return

    questions.forEach(function(question) {
        let answer = question.nextElementSibling;
        let wrap = question.parentNode;
        let inner = answer.querySelector(".faq-item__answer-inner");
        let height = inner.scrollHeight + 15;
        answer.setAttribute('data-height', height);

        let dataHeight = answer.getAttribute('data-height');

        if (!answer.classList.contains("first")) {
            answer.style.height = "0px";
        }
        
        if (answer.classList.contains("first"))  {
            answer.style.height = dataHeight + "px";
        }

        window.addEventListener( 'resize', () => {
            height = inner.scrollHeight + 15;
            answer.setAttribute('data-height', height);
            dataHeight = answer.getAttribute('data-height');
            
            if ( wrap.classList.contains("open") )  {
                answer.style.height = dataHeight + "px";
            }
        } );

        question.addEventListener("click", function() {
            this.parentNode.classList.toggle("open");
            this.nextElementSibling.style.height = this.nextElementSibling.style.height == "0px" ? dataHeight + "px" : "0px";
        });
    });
}